export const COMPANY_DOCUMENTS_LANGUAGE_STORAGE_KEY =
  "qaptive.companyDocuments.language";

export const DEFAULT_COMPANY_DOCUMENTS_LANGUAGE = "id";

export const SUPPORTED_COMPANY_DOCUMENTS_LANGUAGES = [
  "id",
  "en",
];

export const companyDocumentsTranslations = {
  id: {
    language: {
      label: "Bahasa",
      control: "Pilihan bahasa Dokumen Perusahaan",
      id: "ID",
      en: "EN",
    },
    reminder: {
      permission:
        "Diperlukan izin Lihat dan Tinjau Dokumen Perusahaan.",
      title:
        "Email Pengingat",
      description:
        "Pilih Emiten, edit Subjek dan Pesan, lalu lihat pratinjau sebelum mengirim. Penerima ditentukan otomatis dari Admin Perusahaan yang aktif.",
      template:
        "Templat",
      selectAll:
        "Pilih Semua",
      clear:
        "Bersihkan",
      allSelected:
        "Semua Emiten Aktif dipilih",
      available:
        "{{count}} Emiten tersedia",
      selectedIssuers:
        "Emiten Terpilih",
      liveAll:
        "Semua Emiten terpilih",
      liveIssuer:
        "Nama Emiten",
      liveMissing:
        "• Item yang belum lengkap akan ditampilkan otomatis saat pratinjau.",
      editor: {
        title:
          "Editor Email",
        placeholder:
          "Penanda: {{company_name}} dan {{missing_items}}",
        subject:
          "Subjek",
        message:
          "Pesan",
        testRecipient:
          "Email Penerima Uji",
        testHelp:
          "Saat alamat ini terisi, Mode Uji aktif: pilihan Emiten dikosongkan serta dikunci. Email uji hanya mengirim Subjek dan Pesan di editor ke alamat ini.",
      },
      actions: {
        saveTemplate:
          "Simpan Templat",
        sendTest:
          "Kirim Email Uji",
        preview:
          "Pratinjau Pengingat",
        send:
          "Kirim Pengingat",
      },
      editing:
        "Mengedit templat: {{name}}",
      livePreview:
        "Pratinjau Email Langsung",
      previewSubject:
        "Subjek",
      validatedPreview:
        "Pratinjau Tervalidasi",
      recipientSummary:
        "{{companies}} Emiten · {{recipients}} email tujuan otomatis",
      recipientValidated:
        "Cakupan penerima tervalidasi",
      result: {
        templateSaved:
          "Templat \"{{name}}\" berhasil disimpan.",
        testSent:
          "Email uji berhasil dikirim ke {{recipient}}.",
        queued:
          "Pengingat masuk antrean pengiriman.",
      },
    },
    adminReview: {
      tabs: {
        aria: "Bagian peninjauan dokumen",
        documents: "Dokumen",
        companyProfile: "Profil Perusahaan",
      },
      documentPreview: {
        loading: "Memuat pratinjau PDF",
        title: "Pratinjau PDF v{{version}}",
        invalidPdf:
          "Pratinjau PDF tidak tersedia: respons bukan file PDF. Anda masih dapat mencoba Unduh.",
        unavailable:
          "Pratinjau tidak tersedia. Anda masih dapat mencoba Unduh.",
      },
      common: {
        issuer: "Emiten",
        allIssuers: "Semua Emiten",
        status: "Status",
        all: "Semua",
        submitted: "Diajukan",
        needRevision: "Perlu Revisi",
        verified: "Terverifikasi",
        approved: "Disetujui",
        rejected: "Ditolak",
        refresh: "Muat Ulang",
        review: "Tinjau",
        action: "Aksi",
        version: "Versi",
        uploaded: "Diunggah",
        user: "User {{id}}",
        admin: "Admin {{id}}",
        close: "Tutup",
        filename: "Nama File",
        reviewed: "Ditinjau",
        reviewedBy: "Ditinjau oleh",
        uploadedBy: "Diunggah oleh",
        noteFromSigu: "Catatan dari SIGU",
        latest: "Terbaru",
        previous: "Sebelumnya",
      },
      presentation: {
        founder: "Pemegang Saham Pendiri — {{name}}",
        management: "Manajemen",
        company: "Perseroan / Emiten",
        companyNpwp: "NPWP Perseroan",
      },
      documents: {
        title: "Peninjauan Dokumen",
        description:
          "Versi terbaru yang diunggah. Buka dokumen untuk meninjau dan melihat riwayatnya.",
        section: "Bagian Dokumen",
        allSections: "Semua Bagian",
        corporate: "Kredensial Perusahaan",
        management:
          "Manajemen & Sekretaris Perusahaan",
        document: "Dokumen",
        contextOwner: "Konteks / Pemilik",
        historical:
          "Versi Historis — Hanya Baca. Hanya versi terbaru yang dapat ditinjau.",
        saveSuccess: "Peninjauan dokumen berhasil disimpan.",
        needRevision: "Perlu Revisi",
        verify: "Verifikasi",
        verifyQuestion:
          "Verifikasi versi dokumen ini (v{{version}})?",
        revisionQuestion:
          "Minta revisi untuk v{{version}}",
        revisionNote: "Catatan Revisi",
        revisionHelper:
          "Jelaskan alasan dokumen perlu diperbaiki atau diunggah ulang. Maksimum 2000 karakter.",
        cancel: "Batal",
        confirmVerify: "Konfirmasi Verifikasi",
        confirmRevision:
          "Konfirmasi Perlu Revisi",
        history: "Riwayat versi",
        openVersion: "Buka v{{version}}",
      },
      profile: {
        title: "Peninjauan Profil Perusahaan",
        description:
          "Tinjau permintaan perubahan Nama Perusahaan.",
        nameChange: "Perubahan Nama",
        requester: "Pemohon",
        submitted: "Diajukan",
        effective: "Efektif",
        companyNameChange:
          "Perubahan Nama Perusahaan",
        companyContext: "Perseroan / Emiten",
        submittedBy: "Diajukan oleh",
        currentName: "Nama Saat Ini",
        proposedName: "Nama yang Diajukan",
        effectiveDate: "Tanggal Efektif",
        pdfPreview: "Pratinjau PDF",
        pdfTitle:
          "PDF pendukung perubahan nama perusahaan",
        reject: "Tolak",
        approve: "Setujui",
        approveQuestion:
          "Setujui perubahan nama perusahaan ini?",
        rejectQuestion:
          "Tolak perubahan nama perusahaan ini?",
        reviewNote: "Catatan Tinjauan",
        rejectHelper:
          "Jelaskan alasan perubahan nama ditolak. Maksimum 2000 karakter.",
        cancel: "Batal",
        confirmApprove: "Konfirmasi Persetujuan",
        confirmReject: "Konfirmasi Penolakan",
        approvedSuccess:
          "Perubahan nama perusahaan disetujui.",
        rejectedSuccess:
          "Perubahan nama perusahaan ditolak.",
      },
      overview: {
        title: "{{name}} — Dokumen Perusahaan",
        nameChanges: "Perubahan Nama Perusahaan",
        selectAll: "Pilih Semua",
        downloadZip: "Unduh ZIP",
        noNameChanges: "Belum ada permintaan perubahan nama.",
      },
    },
    client: {
      sections: {
        control: "Bagian Dokumen Perusahaan",
        profile: "Profil Perusahaan",
        corporate: "Kredensial Perusahaan",
        management: "Manajemen & Sekretaris Perusahaan",
      },
      common: {
        retry: "Coba Lagi",
        edit: "Ubah",
        bulkUpload: "Unggah Massal",
        required: "Wajib",
        requiredFounderLegal:
          "Wajib: Anggaran Dasar atau Akta Terakhir",
        needsRevision: "perlu revisi",
        individual: "Perorangan",
        legalEntity: "Badan Hukum",
        cancel: "Batal",
      },
      completion: {
        complete: "Lengkap",
        needsAttention: "Perlu Perhatian",
        completeDescription:
          "Semua data wajib untuk bagian ini sudah tersedia.",
        attentionDescription:
          "{{count}} item perlu dilengkapi atau diperbaiki.",
        actionRequired: "Perlu Tindakan",
        more: "{{count}} lainnya",
      },
      corporate: {
        title: "Kredensial Perusahaan",
        description:
          "Dokumen perusahaan dan data Pemegang Saham Pendiri.",
        founderTitle: "Pemegang Saham Pendiri",
        founderDescription:
          "Perorangan: KTP. Badan Hukum: Anggaran Dasar atau Akta Terakhir.",
      },
      management: {
        title: "Manajemen & Sekretaris Perusahaan",
        description:
          "Dokumen Direksi, Dewan Komisaris, serta Sekretaris Perusahaan / PIC.",
        directorsTitle: "Susunan Direksi:",
        directorsInstruction:
          "unggah 1 file PDF yang memuat daftar nama Direksi beserta KTP dan NPWP.",
        commissionersTitle: "Susunan Dewan Komisaris:",
        commissionersInstruction:
          "unggah 1 file PDF yang memuat daftar nama Komisaris beserta KTP dan NPWP.",
      },
      founder: {
        issuePrefix: "Pendiri {{name}}: ",
        missingOwner: "Pemegang Saham Pendiri",
        alternativeDocument:
          "Anggaran Dasar atau Akta Terakhir",
        add: "+ Tambah Pemegang Saham Pendiri",
        empty: "Belum ada data Pemegang Saham Pendiri.",
        editTitle: "Edit Pemegang Saham Pendiri",
        addTitle: "Tambah Pemegang Saham Pendiri",
        type: "Jenis Pemegang Saham Pendiri",
        legalName: "Nama Badan Hukum",
        individualName: "Nama Pemegang Saham Pendiri",
        requirement:
          "Perorangan memerlukan KTP. Badan Hukum memerlukan Anggaran Dasar atau Akta Terakhir.",
        saveChanges: "Simpan Perubahan",
        saveNew: "Simpan Pemegang Saham Pendiri",
        legalInstruction:
          "Badan Hukum pendiri: unggah Anggaran Dasar atau Akta Terakhir.",
      },
      contacts: {
        invalidSection:
          "Sekretaris Perusahaan / PIC hanya tersedia pada Manajemen & Sekretaris Perusahaan.",
        title: "Sekretaris Perusahaan / PIC",
        description:
          "Isi kontak aktif Sekretaris Perusahaan / PIC untuk bagian Manajemen & Sekretaris Perusahaan.",
        name: "Nama {{index}}",
        email: "Email {{index}}",
        phone: "No. Telepon {{index}}",
        remove: "Hapus",
        add: "+ Tambah Contact",
        save: "Simpan Kontak",
        issueName: "Sekretaris Perusahaan / PIC — nama",
        issueEmail: "Sekretaris Perusahaan / PIC — email",
        issuePhone: "Sekretaris Perusahaan / PIC — telepon",
      },
      documents: {
        actions: {
          view: "Lihat",
          download: "Unduh",
          popupBlocked:
            "Izinkan tab baru untuk melihat dokumen ini, atau gunakan Unduh.",
        },
        status: {
          missing: "Belum Ada",
          submitted: "Diajukan",
          verified: "Terverifikasi",
          needRevision: "Perlu Revisi",
          approved: "Disetujui",
          rejected: "Ditolak",
          unavailable: "Tidak Tersedia",
        },
        checklist: {
          document: "Dokumen",
          status: "Status",
          latestFile: "File Terbaru",
          version: "Versi",
          actions: "Aksi",
          required: "Wajib",
          optional: "Opsional",
          siguNote: "Catatan dari SIGU",
          reviewed: "Ditinjau",
          admin: "Admin {{id}}",
          notUploaded: "Belum diunggah",
          uploadNewVersion: "Unggah Versi Baru",
          replace: "Ganti",
          upload: "Unggah",
          viewHistory: "Lihat Riwayat",
        },
      },
      history: {
        title: "{{name}} — Riwayat Versi",
        version: "Versi",
        file: "File",
        status: "Status",
        uploaded: "Diunggah",
        actions: "Aksi",
        latest: "Versi Terbaru",
        previous: "Versi Sebelumnya",
        review: "Tinjau",
        by: "Oleh",
        reviewed: "Ditinjau",
        user: "User {{id}}",
        admin: "Admin {{id}}",
        close: "Tutup",
      },
      upload: {
        validation: {
          pdfOnly:
            "Hanya file PDF yang diperbolehkan.",
          selectType:
            "Pilih jenis dokumen",
          uniqueType:
            "Setiap file harus menggunakan jenis dokumen yang berbeda",
          unsupported:
            "Ekstensi tidak didukung",
          empty:
            "File kosong",
          maximum:
            "Maksimum {{max}} MB",
        },
        chooseOne:
          "Pilih satu file untuk slot dokumen ini.",
        maxTen:
          "Unggah maksimal 10 file sekaligus.",
        success:
          "{{count}} dokumen berhasil diajukan.",
        duplicate:
          " {{count}} file sama dengan versi sebelumnya; versi baru tetap disimpan.",
        bulkTitle:
          "Unggah Massal",
        title:
          "Unggah {{name}}",
        shareholder:
          "Pemegang Saham: {{name}}. Setiap file dalam unggahan ini milik pemegang saham tersebut.",
        bulkDescription:
          "Petakan setiap file ke jenis dokumen. Kecocokan nama file hanya saran; periksa setiap pemetaan sebelum menyimpan.",
        singleDescription:
          "File ini ditetapkan ke slot dokumen ini. Mengganti file akan membuat versi baru dan mempertahankan versi sebelumnya.",
        pdfOnly:
          "Hanya file PDF yang diperbolehkan.",
        dragFiles:
          "Seret dan lepas file di sini",
        dragFile:
          "Seret dan lepas file di sini",
        browse:
          "Pilih file",
        inputAria:
          "File dokumen",
        maxSingle:
          "Hanya PDF · Maks. {{max}} MB",
        maxBulk:
          "Hanya PDF · Maksimal 10 file · total di bawah 49 MB",
        typeFor:
          "Jenis dokumen untuk {{name}}",
        selectType:
          "Pilih jenis dokumen",
        ready:
          "Siap",
        remove:
          "Hapus",
        combined:
          "Pastikan total file di bawah 49 MB.",
        confirm:
          "Saya sudah memeriksa jenis dokumen untuk setiap file",
        cancel:
          "Batal",
        uploading:
          "Mengunggah…",
        submit:
          "Unggah Dokumen",
      },
      profile: {
        title: "Nama Perusahaan",
        description:
          "Informasi nama perseroan dan identitas emiten.",
        requestChange: "Ajukan Perubahan Nama",
        currentCompanyName: "Nama Perseroan Saat Ini",
        editListing: "Edit Data Listing",
        saveListingAria: "Simpan Informasi Listing",
        cancelListingAria:
          "Batal Edit Informasi Listing",
        saving: "Menyimpan...",
        save: "Simpan",
        cancel: "Batal",
        issuerCode: "Kode Emiten",
        listingName: "Nama pada Saat Listing",
        listingDate: "Tanggal Listing",
        listingDateRequired:
          "Tanggal Listing wajib diisi.",
        listingUpdated:
          "Informasi listing berhasil diperbarui.",
        pending:
          "Permintaan perubahan nama sedang menunggu verifikasi SIGU. Pengajuan baru dapat dilakukan setelah permintaan ini selesai ditinjau.",
        currentName: "Nama saat ini:",
        newName: "Nama Perseroan Baru",
        characters: "{{count}}/100 karakter",
        effectiveChangeDate:
          "Tanggal Efektif Perubahan",
        supportingDocument: "Dokumen Pendukung",
        supportingDescription:
          "Unggah satu file PDF yang berisi Akta Perubahan Nama Perseroan beserta dokumen atau pemberitahuan terkait dari AHU.",
        choosePdf: "Pilih PDF",
        noFile: "Belum ada file dipilih",
        historyTitle: "Riwayat Perubahan Nama",
        historyDescription:
          "Pengajuan yang sudah selesai ditinjau.",
        requestCard: {
          title: "Perubahan Nama Perseroan",
          effectiveDate: "Tanggal Efektif",
          submitted: "Diajukan",
          supportingDocument: "Dokumen Pendukung",
          submittedBy: "Diajukan oleh",
          note: "Catatan SIGU",
          preview: "Pratinjau",
          download: "Unduh",
          popupBlocked:
            "Izinkan tab baru untuk melihat pratinjau dokumen ini, atau gunakan Unduh.",
          previewUnavailable: "Pratinjau PDF tidak tersedia.",
        },
        status: {
          submitted: "Menunggu Verifikasi",
          approved: "Disetujui",
          rejected: "Ditolak",
        },
      },
    },
  },
  en: {
    language: {
      label: "Language",
      control: "Company Documents language selector",
      id: "ID",
      en: "EN",
    },
    reminder: {
      permission:
        "Company Documents View and Review permission is required.",
      title:
        "Reminder Email",
      description:
        "Select issuers, edit the Subject and Message, then review the preview before sending. Recipients are determined automatically from active Company Admin accounts.",
      template:
        "Template",
      selectAll:
        "Select All",
      clear:
        "Clear",
      allSelected:
        "All Active Issuers selected",
      available:
        "{{count}} issuers available",
      selectedIssuers:
        "Selected Issuers",
      liveAll:
        "All issuers selected",
      liveIssuer:
        "Issuer Name",
      liveMissing:
        "• Incomplete items will be shown automatically in the preview.",
      editor: {
        title:
          "Email Editor",
        placeholder:
          "Placeholder: {{company_name}} and {{missing_items}}",
        subject:
          "Subject",
        message:
          "Message",
        testRecipient:
          "Test Recipient Email",
        testHelp:
          "When this address is filled in, Test Mode is active: issuer selection is cleared and locked. The test email only sends the Subject and Message from the editor to this address.",
      },
      actions: {
        saveTemplate:
          "Save Template",
        sendTest:
          "Send Test Email",
        preview:
          "Preview Reminder",
        send:
          "Send Reminder",
      },
      editing:
        "Editing template: {{name}}",
      livePreview:
        "Live Email Preview",
      previewSubject:
        "Subject",
      validatedPreview:
        "Validated Preview",
      recipientSummary:
        "{{companies}} issuers · {{recipients}} automatic recipient emails",
      recipientValidated:
        "Recipient scope validated",
      result: {
        templateSaved:
          "Template \"{{name}}\" saved.",
        testSent:
          "Test email sent to {{recipient}}.",
        queued:
          "Reminder queued.",
      },
    },
    adminReview: {
      tabs: {
        aria: "Document review sections",
        documents: "Documents",
        companyProfile: "Company Profile",
      },
      documentPreview: {
        loading: "Loading PDF preview",
        title: "PDF preview v{{version}}",
        invalidPdf:
          "PDF preview unavailable: the response is not a PDF. You can still try Download.",
        unavailable:
          "Preview unavailable. You can still try Download.",
      },
      common: {
        issuer: "Issuer",
        allIssuers: "All Issuers",
        status: "Status",
        all: "All",
        submitted: "Submitted",
        needRevision: "Need Revision",
        verified: "Verified",
        approved: "Approved",
        rejected: "Rejected",
        refresh: "Refresh",
        review: "Review",
        action: "Action",
        version: "Version",
        uploaded: "Uploaded",
        user: "User {{id}}",
        admin: "Admin {{id}}",
        close: "Close",
        filename: "Filename",
        reviewed: "Reviewed",
        reviewedBy: "Reviewed by",
        uploadedBy: "Uploaded by",
        noteFromSigu: "Note from SIGU",
        latest: "Latest",
        previous: "Previous",
      },
      presentation: {
        founder: "Founder Shareholder — {{name}}",
        management: "Management",
        company: "Company / Issuer",
        companyNpwp: "Company NPWP",
      },
      documents: {
        title: "Document Review",
        description:
          "Latest uploaded versions. Open a document to review it and view its history.",
        section: "Document Section",
        allSections: "All Sections",
        corporate: "Corporate Credentials",
        management:
          "Management & Corporate Secretary",
        document: "Document",
        contextOwner: "Context / Owner",
        historical:
          "Historical Version — Read Only. Only the latest version can be reviewed.",
        saveSuccess: "Document review saved.",
        needRevision: "Need Revision",
        verify: "Verify",
        verifyQuestion:
          "Verify this document version (v{{version}})?",
        revisionQuestion:
          "Request revision for v{{version}}",
        revisionNote: "Revision Note",
        revisionHelper:
          "Explain why the document must be corrected or uploaded again. Maximum 2000 characters.",
        cancel: "Cancel",
        confirmVerify: "Confirm Verify",
        confirmRevision:
          "Confirm Need Revision",
        history: "Version history",
        openVersion: "Open v{{version}}",
      },
      profile: {
        title: "Company Profile Review",
        description:
          "Review Company Name change requests.",
        nameChange: "Name Change",
        requester: "Requester",
        submitted: "Submitted",
        effective: "Effective",
        companyNameChange:
          "Company Name Change",
        companyContext: "Company / Issuer",
        submittedBy: "Submitted by",
        currentName: "Current Name",
        proposedName: "Proposed Name",
        effectiveDate: "Effective Date",
        pdfPreview: "PDF preview",
        pdfTitle:
          "Company name supporting PDF",
        reject: "Reject",
        approve: "Approve",
        approveQuestion:
          "Approve this company name change?",
        rejectQuestion:
          "Reject this company name change?",
        reviewNote: "Review Note",
        rejectHelper:
          "Explain why the company name change is rejected. Maximum 2000 characters.",
        cancel: "Cancel",
        confirmApprove: "Confirm Approve",
        confirmReject: "Confirm Reject",
        approvedSuccess:
          "Company name change approved.",
        rejectedSuccess:
          "Company name change rejected.",
      },
      overview: {
        title: "{{name}} — Company Documents",
        nameChanges: "Company Name Changes",
        selectAll: "Select All",
        downloadZip: "Download ZIP",
        noNameChanges: "No company name change requests yet.",
      },
    },
    client: {
      sections: {
        control: "Company Documents sections",
        profile: "Company Profile",
        corporate: "Corporate Credentials",
        management: "Management & Corporate Secretary",
      },
      common: {
        retry: "Retry",
        edit: "Edit",
        bulkUpload: "Bulk Upload",
        required: "Required",
        requiredFounderLegal:
          "Required: Articles of Association or Latest Deed",
        needsRevision: "needs revision",
        individual: "Individual",
        legalEntity: "Legal Entity",
        cancel: "Cancel",
      },
      completion: {
        complete: "Complete",
        needsAttention: "Needs attention",
        completeDescription:
          "All required data for this section is available.",
        attentionDescription:
          "{{count}} items need to be completed or corrected.",
        actionRequired: "Action required",
        more: "{{count}} more",
      },
      corporate: {
        title: "Corporate Credentials",
        description:
          "Company documents and Founder Shareholder information.",
        founderTitle: "Founder Shareholders",
        founderDescription:
          "Individual: ID Card (KTP). Legal Entity: Articles of Association or Latest Deed.",
      },
      management: {
        title: "Management & Corporate Secretary",
        description:
          "Board of Directors, Board of Commissioners, and Corporate Secretary / PIC documents.",
        directorsTitle: "Board of Directors:",
        directorsInstruction:
          "upload one PDF containing the list of Directors together with their KTP and NPWP.",
        commissionersTitle: "Board of Commissioners:",
        commissionersInstruction:
          "upload one PDF containing the list of Commissioners together with their KTP and NPWP.",
      },
      founder: {
        issuePrefix: "Founder {{name}}: ",
        missingOwner: "Founder Shareholder",
        alternativeDocument:
          "Articles of Association or Latest Deed",
        add: "+ Add Founder Shareholder",
        empty: "No Founder Shareholder data yet.",
        editTitle: "Edit Founder Shareholder",
        addTitle: "Add Founder Shareholder",
        type: "Founder Shareholder Type",
        legalName: "Legal Entity Name",
        individualName: "Founder Shareholder Name",
        requirement:
          "Individuals require KTP. Legal Entities require Articles of Association or the Latest Deed.",
        saveChanges: "Save changes",
        saveNew: "Save founder",
        legalInstruction:
          "Founder Legal Entity: upload the Articles of Association or Latest Deed.",
      },
      contacts: {
        invalidSection:
          "Corporate Secretary / PIC is only available under Management & Corporate Secretary.",
        title: "Corporate Secretary / PIC",
        description:
          "Enter active Corporate Secretary / PIC contact details for the Management & Corporate Secretary section.",
        name: "Name {{index}}",
        email: "Email {{index}}",
        phone: "Phone No. {{index}}",
        remove: "Remove",
        add: "+ Add Contact",
        save: "Save Contacts",
        issueName: "Corporate Secretary / PIC — name",
        issueEmail: "Corporate Secretary / PIC — email",
        issuePhone: "Corporate Secretary / PIC — phone",
      },
      documents: {
        actions: {
          view: "View",
          download: "Download",
          popupBlocked:
            "Allow a new tab to view this document, or use Download.",
        },
        status: {
          missing: "Missing",
          submitted: "Submitted",
          verified: "Verified",
          needRevision: "Need Revision",
          approved: "Approved",
          rejected: "Rejected",
          unavailable: "Unavailable",
        },
        checklist: {
          document: "Document",
          status: "Status",
          latestFile: "Latest file",
          version: "Version",
          actions: "Actions",
          required: "Required",
          optional: "Optional",
          siguNote: "Note from SIGU",
          reviewed: "Reviewed",
          admin: "Admin {{id}}",
          notUploaded: "Not uploaded yet",
          uploadNewVersion: "Upload New Version",
          replace: "Replace",
          upload: "Upload",
          viewHistory: "View History",
        },
      },
      history: {
        title: "{{name}} — Version History",
        version: "Version",
        file: "File",
        status: "Status",
        uploaded: "Uploaded",
        actions: "Actions",
        latest: "Latest version",
        previous: "Previous version",
        review: "Review",
        by: "By",
        reviewed: "Reviewed",
        user: "User {{id}}",
        admin: "Admin {{id}}",
        close: "Close",
      },
      upload: {
        validation: {
          pdfOnly:
            "Only PDF files are allowed.",
          selectType:
            "Select a document type",
          uniqueType:
            "Each file needs a different document type",
          unsupported:
            "Unsupported extension",
          empty:
            "File is empty",
          maximum:
            "Maximum {{max}} MB",
        },
        chooseOne:
          "Choose one file for this document slot.",
        maxTen:
          "Upload at most 10 files at a time.",
        success:
          "{{count}} document{{suffix}} submitted.",
        duplicate:
          " {{count}} file(s) match the previous version; a new version was retained.",
        bulkTitle:
          "Bulk Upload",
        title:
          "Upload {{name}}",
        shareholder:
          "Shareholder: {{name}}. Every file in this upload belongs to this shareholder.",
        bulkDescription:
          "Map each file to a document type. Filename matches are suggestions; check every mapping before saving.",
        singleDescription:
          "This file is assigned to this document slot. Replacing a file creates a new version and keeps the previous version.",
        pdfOnly:
          "Only PDF files are allowed.",
        dragFiles:
          "Drag and drop files here",
        dragFile:
          "Drag and drop a file here",
        browse:
          "Browse files",
        inputAria:
          "Document files",
        maxSingle:
          "PDF only · Max. {{max}} MB",
        maxBulk:
          "PDF only · Up to 10 files · under 49 MB combined",
        typeFor:
          "Document type for {{name}}",
        selectType:
          "Select document type",
        ready:
          "Ready",
        remove:
          "Remove",
        combined:
          "Keep the combined files under 49 MB.",
        confirm:
          "I have checked the document type for every file",
        cancel:
          "Cancel",
        uploading:
          "Uploading…",
        submit:
          "Upload Documents",
      },
      profile: {
        title: "Company Name",
        description:
          "Company name and issuer identity information.",
        requestChange: "Submit Name Change",
        currentCompanyName: "Current Company Name",
        editListing: "Edit Listing Data",
        saveListingAria: "Save Listing Information",
        cancelListingAria:
          "Cancel Listing Information Edit",
        saving: "Saving...",
        save: "Save",
        cancel: "Cancel",
        issuerCode: "Issuer Code",
        listingName: "Name at Listing",
        listingDate: "Listing Date",
        listingDateRequired:
          "Listing Date is required.",
        listingUpdated:
          "Listing information updated successfully.",
        pending:
          "The company name change request is awaiting SIGU verification. A new request can be submitted after this request has been reviewed.",
        currentName: "Current name:",
        newName: "New Company Name",
        characters: "{{count}}/100 characters",
        effectiveChangeDate:
          "Effective Date of Change",
        supportingDocument: "Supporting Document",
        supportingDescription:
          "Upload one PDF containing the Company Name Change Deed together with the related AHU document or notification.",
        choosePdf: "Choose PDF",
        noFile: "No file selected",
        historyTitle: "Name Change History",
        historyDescription:
          "Requests that have completed review.",
        requestCard: {
          title: "Company Name Change",
          effectiveDate: "Effective Date",
          submitted: "Submitted",
          supportingDocument: "Supporting Document",
          submittedBy: "Submitted by",
          note: "SIGU Note",
          preview: "Preview",
          download: "Download",
          popupBlocked:
            "Allow a new tab to preview this document, or use Download.",
          previewUnavailable: "PDF preview unavailable.",
        },
        status: {
          submitted: "Pending Verification",
          approved: "Approved",
          rejected: "Rejected",
        },
      },
    },
  },
};

export const normalizeCompanyDocumentsLanguage = (
  value,
) =>
  SUPPORTED_COMPANY_DOCUMENTS_LANGUAGES.includes(
    value,
  )
    ? value
    : DEFAULT_COMPANY_DOCUMENTS_LANGUAGE;

export const translateCompanyDocuments = (
  language,
  key,
  params = {},
) => {
  const normalized =
    normalizeCompanyDocumentsLanguage(language);

  const result = key
    .split(".")
    .reduce(
      (current, part) =>
        current?.[part],
      companyDocumentsTranslations[
        normalized
      ],
    );

  if (typeof result !== "string") {
    return key;
  }

  return Object.entries(params).reduce(
    (text, [name, value]) =>
      text.replaceAll(
        `{{${name}}}`,
        String(value),
      ),
    result,
  );
};
